// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Asset Class Forecast",
    titleHelp: "Optional heading to display above the forecast",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showChart: "Show Chart",
    showChartHelp: "Display the stacked bar chart",
    showTable: "Show Table",
    showTableHelp: "Display the closing asset class mix as a table",
    validationError: "At least one display option must be selected",
    validationErrorLong: "At least one display option (Chart or Table) must be selected",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Aktivaklasseprognose",
    titleHelp: "Valgfri overskrift som vises over prognosen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showChart: "Vis diagram",
    showChartHelp: "Vis det stablede stolpediagrammet",
    showTable: "Vis tabell",
    showTableHelp: "Vis den avsluttende aktivaklassefordelingen som tabell",
    validationError: "Minst ett visningsalternativ må være valgt",
    validationErrorLong: "Minst ett visningsalternativ (diagram eller tabell) må være valgt",
  },
} as const;
